import styled from 'styled-components';

export const StyledModalWrapper = styled.div`
  width: 100%;
`;

export const StyledModalHeading = styled.h5`
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  color: #000000;
  margin-bottom: 35px;
`;

export const StyledModalSubHeading = styled.label`
  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 143%;
  color: #8d8c91;
`;

export const StyledModalSubmitButton = styled.input`
  background: #02bf8e;
  font-family: 'futura-pt', sans-serif;
  font-weight: 500 !important;
  font-size: 17px !important;
  line-height: 24px;
  color: #fff;
  padding: 14.5px;
  justify-content: center;
  border: none;
  min-width: 183px;
  margin: 24px 0 0;
  max-height: 55px;
  display: flex;
  transition: all 0.3s ease-in-out 0s;
  &:hover {
    box-shadow: none;
    transform: translateY(-3px);
    text-decoration: none;
  }
  @media (max-width: 768px) {
    max-width: 155px;
    min-width: 155px;
    margin-right: 0;
  }
`;

export const StyledModalCancelButton = styled.p`
  line-height: 26px;
  font-family: 'futura-pt', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #8d8c91;
  margin: 24px 12px 0;
  display: flex;
  align-items: center;
  margin-left: 30px;
  margin-right: 30px;
  cursor: pointer;
  transition: all 0.3s ease-in-out 0s;
  &:hover {
    box-shadow: none;
    transform: translateY(-3px);
    text-decoration: none;
  }
  @media (max-width: 768px) {
    margin: 10px;
  }
`;

export const StyledModalButtonsContainer = styled.div`
  display: flex;
  margin-top: 16px;
  justify-content: center;
  @media (max-width: 768px) {
    input {
      margin: 0 !important;
    }
  }
`;
